import Grid from '@material-ui/core/Grid';
import PeFormTextField from '@pe-libs/react-components/build/components/PeFormTextField';
import useIntlMessage from '@pe-libs/react-components/build/lib/intl/hooks/useIntlMessage';
import React, { useRef, useEffect } from 'react';
import messages from './messages';
import Buttons from './pageElements/PeOnboardingButtons';
import OnboardingIntro from './pageElements/PeOnboardingIntro';
import Stepper from './pageElements/PeOnboardingStepper';
import useStyles from './styles';
import { OnboardingStepType } from './types';

const PeOnboardingPage2: OnboardingStepType = ({ formik, wizardMethods, actions }) => {
  const styles = useStyles();
  const formatMessage = useIntlMessage();
  const profileTitleInputReference = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (profileTitleInputReference?.current) {
      profileTitleInputReference.current.focus();
    }
  }, []);

  return (
    <Grid container={true} spacing={3}>
      <Grid item={true} xs={12}>
        <OnboardingIntro title={formatMessage(messages.titlestep2)} desc={formatMessage(messages.descstep2)} />
        <Stepper {...wizardMethods} actions={actions} />
      </Grid>
      <Grid item={true} xs={12}>
        <PeFormTextField
          inputRef={profileTitleInputReference}
          formik={formik}
          type="text"
          name="page2.profileTitle"
          label={`${formatMessage(messages.profilenamelabel)}*`}
        />
      </Grid>
      <div className={styles.requiredText}>{formatMessage(messages.required)}</div>
      <Buttons {...wizardMethods} />
    </Grid>
  );
};

export default PeOnboardingPage2;
